var lilly = lilly || {};
(function () {
    'use strict';
    lilly.search = {
        init: function () {
            jQuery('.js-lilly-search-form').on('submit', function (event) {
                event.preventDefault();
                var customSearchBarValue = jQuery(event.target).find('.js-lilly-search-input').val();
                e4.util.hash.set('search', customSearchBarValue);
            });
        }
    };
    lilly.productStockInCart = {
        init: function () {
            lilly.productStockInCart.bindEvents()
        },
        bindEvents: function () {
            
        }
    };
    lilly.productImageZoom = {
        init: function () {
            jQuery( '.js-e-product-images' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
                jQuery('.js-carousel-item-image-zoom').each(function (index, imageElm) {
                    jQuery(imageElm).zoom({
                        url: imageElm.dataset.src,
                        magnify: 1.2,
                        on: 'click',
                        onZoomIn: function () {
                            jQuery(this).addClass('zoom-in');
                        },
                        onZoomOut: function () {
                            jQuery(this).removeClass('zoom-in');
                        }
                    });
                });
            });
        }
    };
    lilly.productVimeo = {
        init: function () {
            if(typeof Cookiebot != 'undefined') {
                if(Cookiebot.consent.marketing === true ) {
                    jQuery('.js-e-product-images, #js-e-product-image-modal').on('slide.bs.carousel', '#js-e-product-image-carousel', function (event) {
    
                        // pause
    
                        var allVimeoIframes = jQuery(event.target).find('.js-product-vimeo-player');
    
                        allVimeoIframes.each(function (intIndex, domNode) {
                            var vimeoPlayer = new Vimeo.Player(domNode);
                            vimeoPlayer.pause();
                            vimeoPlayer.setVolume(0);
                        });
    
                        // play
    
                        var jCurrentSlide = jQuery(event.relatedTarget);
                        var jVimeoIframe = jCurrentSlide.find('.js-product-vimeo-player');
    
                        if (jVimeoIframe.length === 1) {
                            var vimeoPlayer = new Vimeo.Player(jVimeoIframe.get(0));
                            vimeoPlayer.play();
                        }
    
                    });
                }
            }
        }
    };
    
    lilly.variant = {
        init: function () {
            jQuery('.js-e-product-images').on('loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function (event) {
                
                
                if (jQuery( '.js-e-product-form').data('parent-stock') > 0 && jQuery('.js-e-product').data('variantId') == "") {
                    jQuery('.js-lilly-cart-quantity').attr('data-stock', jQuery( '.js-e-product-form').data('parent-stock'))
                }

                lilly.variant.setDetails(jQuery('.js-e-product').data('variantId'));
                
            });

            jQuery('.js-e-product-form').on('input', '.js-lilly-cart-quantity', function (event) {
                jQuery('.js-e-product-form-variant-group-input').trigger('change');
            });
            jQuery('.js-e-product-form-variant-group-input').on('change', function (event) {
                lilly.variant.setDetails(event.target.value);

                //jQuery('.js-e-product').attr('data-variant-id', jQuery('.js-e-product-form-variant-group-input').val())
            }) 
        },
        setDetails: function ( strVariantId ) {

            var jProduct = jQuery( '.js-e-product' ),
                strProductId = jProduct.data( 'productId' ),
                strVariantId = jQuery('.js-e-product-form-variant-group-input').val(),

                strDataPropertyPath = [
                    strProductId,
                    'variantCombinations',
                    strVariantId
                ].join('.'),

                strMainDataPropertyPath = [
                    strProductId
                ].join('.');


            var data = null;
            if (jProduct.data( 'variantId' ) !== "") {
                data = e4.data.get(strDataPropertyPath)
            } else {
                data = e4.data.get(strMainDataPropertyPath)
            }

            e4.cart.ajax( {
                method: 'GET'
            }, function ( jsonData ) {
                e4.cart.disableAddToCartButtonIfLowOnStock(jsonData);
            } );
            
            if (data.stock.quantity > 0) {
                if (data.IsPreorder === false) {
                    jQuery('.js-lilly-cart-quantity').attr('data-stock', data.stock.quantity);
                } else {
                }
            } else {
                jQuery('.js-lilly-cart-quantity').attr('data-stock', "");
            }
            
            if (data.stock.quantity < parseInt(jQuery('.js-lilly-cart-quantity').val())) {
                jQuery('.js-product-ispreorder-orderlinefield').val('true')
                jQuery('.js-lilly-preorder-info').removeClass("d-none")
            } else {
                jQuery('.js-product-ispreorder-orderlinefield').val('')
                jQuery('.js-lilly-preorder-info').addClass("d-none")
            }
            
                var jsonFavorites = e4.data.get( 'favoritelist' );
                
                jProduct.find( '.js-e-favorite-list' ).each( function ( intIndex, domNode ) {
                    var jListInput = jQuery( domNode ),
                        strListUrlAdd = String( jListInput.data( 'url-add' ) ),
                        strListUrlRemove = String( jListInput.data( 'url-remove' ) ),
                        strListUrlAddNew = strListUrlAdd.replace( /(VariantID=).*?(&)/, '$1' + strVariantId + '$2' ),
                        strListUrlRemoveNew = strListUrlRemove.replace( /(VariantID=).*?(&)/, '$1' + strVariantId + '$2' );
                    jListInput.data( 'url-add', strListUrlAddNew );
                    jListInput.data( 'url-remove', strListUrlRemoveNew );

                    jsonFavorites.forEach(function(favoritlist){
                        if(favoritlist.Products.length > 0) {
                            var isVariantInList = favoritlist.Products.filter(function(product){
                                
                                return product.ProductId === strProductId && product.ProductVariantId === strVariantId
                            }).length > 0;

                            jListInput.prop( 'checked', isVariantInList );
                        }
                    })
                    
                } );
            }
        
    }
}());
